import "./InventoryChartKey.css";

import { ColorConstants } from "../../../../../../constants";

interface InventoryChartKeyProps {
  unitMeasurement: string;
  isSalesOverTime: boolean;
  showAllocatedAndAvailable?: boolean;
}

export const InventoryChartKey = ({
  unitMeasurement,
  isSalesOverTime,
  showAllocatedAndAvailable = false,
}: InventoryChartKeyProps): JSX.Element => {
  const isCarbonMeasurement = unitMeasurement === "Carbon";
  const allocatedColour = isCarbonMeasurement ? ColorConstants.INDIGO_500 : ColorConstants.GREEN_600;
  const availableColour = isCarbonMeasurement ? ColorConstants.INDIGO_100 : ColorConstants.GREEN_200;

  return (
    <div className="InventoryChartKey">
      {isSalesOverTime ? (
        <>
          <h3>Total value</h3>
          <div className="KeyItem">
            <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_500 }} />
            <p>Carbon</p>
          </div>
          <div className="KeyItem">
            <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_500 }} />
            <p>Biodiversity</p>
          </div>
        </>
      ) : (
        <>
          <h3>Units</h3>
          {showAllocatedAndAvailable && (
            <>
              <div className="KeyItem">
                <div className="KeyItemColour" style={{ backgroundColor: allocatedColour }} />
                <p>Allocated</p>
              </div>
              <div className="KeyItem">
                <div className="KeyItemColour" style={{ backgroundColor: availableColour }} />
                <p>Available</p>
              </div>
            </>
          )}
          {!showAllocatedAndAvailable &&
            (isCarbonMeasurement ? (
              <>
                <div className="KeyItem">
                  <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_100 }} />
                  <p>Available</p>
                </div>
                <div className="KeyItem">
                  <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_300 }} />
                  <p>Reserved</p>
                </div>
                <div className="KeyItem">
                  <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_500 }} />
                  <p>Sold</p>
                </div>
              </>
            ) : (
              <>
                <div className="KeyItem">
                  <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_200 }} />
                  <p>Available</p>
                </div>
                <div className="KeyItem">
                  <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_400 }} />
                  <p>Reserved</p>
                </div>
                <div className="KeyItem">
                  <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_600 }} />
                  <p>Sold</p>
                </div>
              </>
            ))}
        </>
      )}
    </div>
  );
};
